function searchComponent() {
  return {
    query: '',
    page: 1,
    products: [],
    pages: [],
    recipes: [],
    collections: [],
    totalPages: 0,
    totalRecipePages: 0,
    itemsPerPage: 36,
    showPagination: true,
    totalhits: 0,
    excludedHandles: ['bundle', 'bundle-dummy', 'gratisbuch', 'dein-gratisprodukt', 'dein-gratistee'],

    selectedFacets: [],
    /* priceMin: 0,
    priceMax: 10, */
    type: 'product',


    get combined() {
      const combinedArray = [
        ...this.pages.map(page => ({ ...page, type: 'page' })),
        ...this.recipes.map(recipe => ({ ...recipe, type: 'recipe' }))
      ];
      return combinedArray;
    },

    stripHtmlAndTruncate(html, maxLength) {
      const div = document.createElement('div');
      div.innerHTML = html;
      let text = div.textContent || div.innerText || '';
      if (maxLength && text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
      }
      return text;
    },

    filterProducts(products) {
      return products.filter(product => !this.excludedHandles.includes(product.handle));
    },

    async search() {
      if (this.query.length < 3) return;
      const meilisearchElement = document.querySelector('.meilisearch');

      let url = `https://suche.ankerkraut.de/search?q=${encodeURIComponent(this.query)}&page=${this.page}`;

      if (this.type === 'product' && this.selectedFacets.length > 0) {
        url += `&facets=[${this.selectedFacets.join(',')}]`;
      }

      try {
        const response = await fetch(url).then((res) => res.json());
        console.log(response);
        if (this.type === 'product') {
          /* let allProducts = this.filterProducts(response.products || []);
          this.products = allProducts.filter(product => {
            let p = parseFloat(product.price);
            return p >= this.priceMin && p <= this.priceMax;
          }); */

          /* Without price-range slider */
          this.products = this.filterProducts(response.products || []);
          this.pages = [];
          this.recipes = [];
        } else if (this.type === 'rezepte') {
          this.recipes = (response.recipes || []).filter(recipe => recipe.blog_handle !== "magazin");
          this.pages = [];
          this.products = [];
        } else if (this.type === 'page') {
          this.pages = (response.pages || []).concat((response.recipes || []).filter(recipe => recipe.blog_handle === "magazin"));
          this.recipes = [];
          this.products = [];
        }

        this.collections = response.collections || [];
        this.totalhits = response.totalhits || 0;
        this.totalPages = Math.ceil(response.totalhits / response.hits_per_page);
        console.log("response hits per page", response.hits_per_page);
        console.log("total pages", this.totalPages);

        if (this.type !== 'product') {
          this.selectedFacets = [];
          this.priceMin = 0;
          this.priceMax = 10;
        }

        if (
          this.products.length ||
          this.pages.length ||
          this.recipes.length ||
          this.collections.length
        ) {
          meilisearchElement.classList.add('has-results');
        } else {
          meilisearchElement.classList.remove('has-results');
        }
        Alpine.nextTick(() => {});
      } catch (error) {
        console.error('Error fetching search results:', error);
        meilisearchElement.classList.remove('has-results');
      }
    },

    viewAllResults(event) {
      if (event) event.preventDefault();
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=all`;
    },

    viewAllProducts(event) {
      if (event) event.preventDefault();
      let facetsPart = '';
      if (this.selectedFacets.length > 0) {
        facetsPart = `&facets=[${this.selectedFacets.join(',')}]`;
      }
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=product${facetsPart}`;
    },


    viewAll(event) {
      if (event) event.preventDefault();
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=product`;
    },

    viewAllPages(event) {
      if (event) event.preventDefault();
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=page`;
    },

    viewAllArticles(event) {
      if (event) event.preventDefault();
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=rezepte`;
    },

    goToPage(pageNumber) {
      this.page = pageNumber;
      this.search();
    },

    nextPage() {
      if (this.page < this.totalPages) {
        this.goToPage(this.page + 1);
      }
    },

    previousPage() {
      if (this.page > 1) {
        this.goToPage(this.page - 1);
      }
    },

    resetFacets() {
      this.selectedFacets = [];
      this.search();
    },

    initialize() {
      const params = new URLSearchParams(window.location.search);
      this.query = params.get('query') || '';
      this.type = params.get('type') || 'product';
      const facetsParam = params.get('facets');
      if (facetsParam) {
        let stripped = facetsParam.replace(/^\[|\]$/g, '');
        this.selectedFacets = stripped ? stripped.split(',') : [];
      }
      if (this.query) {
        this.search();
      }
    }

  }
}

document.addEventListener('alpine:init', () => {
  Alpine.store('meilimeta', { enabled: false });
  if (window.location.pathname === '/search') {
    Alpine.store('meilibody', searchComponent());
    Alpine.store('meilibody').initialize();
  }
  Alpine.store('meiliheader', searchComponent());
  Alpine.store('meiliblog', searchComponent());
  Alpine.store('meiliblog').type = 'rezepte';
});

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    }
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
}

const meilisearchElement = document.querySelector('.meilisearch');
const resultsFlex = document.querySelector('.resultsFlex');
resultsFlex.style.display = 'none';
const checkHasResults = debounce(() => {
  if (meilisearchElement.classList.contains('has-results')) {
    console.log("has results");
    resultsFlex.classList.add('isOpen');
  }
}, 700);
document.querySelector('.meiliInputHeader').addEventListener('input', checkHasResults);

/* selecting the element with data action toggle-search */
/* document.querySelectorAll('[data-action="toggle-meilisearch"]').forEach(item => {
  item.addEventListener('click', () => {
    setTimeout(() => {
      console.log("clicked");
      document.querySelectorAll('.filterChip').forEach(item => {
        item.addEventListener('click', checkHasResults);
        if (meilisearchElement.classList.contains('has-results')) {
          resultsFlex.classList.add('isOpen');
          resultsFlex.style.display = 'flex';
        }
      });
    }, 3000);
  });
}); */




async function checkMeilisearchHealth() {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 2000);
    const response = await fetch('https://suche.ankerkraut.de/health', { signal: controller.signal });
    clearTimeout(timeoutId);
    if (!response.ok) {
      throw new Error('Meilisearch health check failed');
    }
    const healthStatus = await response.text();
    if (healthStatus !== 'OK') {
      throw new Error('Meilisearch is not available');
    }
  } catch (error) {
    console.error('Meilisearch health check failed:', error);
    Alpine.store('meilimeta', { enabled: false });
  }
}
checkMeilisearchHealth();

document.addEventListener('DOMContentLoaded', () => {
  const filterButton = document.getElementById('filter-button-mobile');
  const filterCategoryMobile = document.querySelector('.filterCategory-mobile');
  const filterCloseMobile = document.getElementById('filter-close-mobile');
  const filterFlexInput = document.querySelectorAll('.filter-flex input');
  if (!filterButton && filterCategoryMobile) return;

  filterButton.addEventListener('click', (e) => {
    e.preventDefault();
    console.log("filter button clicked");
    filterCategoryMobile.classList.toggle('isOpen');
  });

  if (!filterCloseMobile) return;
  filterCloseMobile.addEventListener('click', (e) => {
    e.preventDefault();
    filterCategoryMobile.classList.remove('isOpen');
  })

  let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    filterCategoryMobile.classList.add('safari');
  }
});